import { Box, FormControl, MenuItem, OutlinedInput, Select } from '@mui/material';

import {
  ExtendedChart,
  ExtendedOptions,
  ExtendedSeriesType
} from '@/components/Chart/types/highcharts';

import useLegendDropdown from './useLegendDropdown';

const LegendItem = ({ series }: { series: ExtendedSeriesType }) => {
  const unitPrice = series.userOptions?.custom
    ? `(${series.userOptions.custom.Currency} / ${series.userOptions.custom.Units})`
    : '';
  return (
    <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <div
        style={{
          width: '8px',
          height: '2px',
          backgroundColor: series.color as string,
          display: 'inline-block',
          marginRight: 4
        }}
      />
      <Box
        style={{
          maxWidth: 550,
          width: '100%',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap'
        }}
      >
        {series.name} {unitPrice}
      </Box>
    </Box>
  );
};

const LegendDropdown = ({
  chart,
  options
}: {
  chart: ExtendedChart | null;
  options: ExtendedOptions | undefined;
}) => {
  const { selectedSeries, allChartSeries, handleLegendItemClick } = useLegendDropdown({
    chart,
    options
  });

  return (
    <Box sx={{ minWidth: 120, pr: 5, pl: 1, pb: 2 }}>
      <FormControl fullWidth>
        <Select
          multiple
          id='legend-select'
          input={<OutlinedInput inputProps={{ pl: 0, height: 34 }} />}
          MenuProps={{
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            MenuListProps: {
              sx: {
                padding: 0
              }
            },
            PaperProps: {
              sx: {
                border: '1px solid #E84E0F',
                borderBottom: 0,
                borderLeft: 0
              }
            }
          }}
          renderValue={seriesArray => {
            return <LegendItem series={seriesArray[0]} />;
          }}
          size='small'
          sx={{
            height: 34,
            '.MuiSelect-select': {
              paddingLeft: 1
            }
          }}
          value={selectedSeries ?? allChartSeries}
          onChange={handleLegendItemClick}
        >
          {allChartSeries?.map(series => {
            return (
              // @ts-expect-error Series type can be value of MenuItem
              <MenuItem
                key={series.index}
                sx={{ '&.MuiButtonBase-root': { pl: 1 } }}
                value={series}
              >
                <LegendItem series={series} />
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LegendDropdown;
